import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useStoryStyleCardContext } from "~/components/story-style/story-style-card/contexts";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";
import { tracking } from "~/data";
import type { linkStoryStyleCardLinkArticle$key } from "~/queries/__generated__/linkStoryStyleCardLinkArticle.graphql";

import { CardLinkContainer, StyledEntityLink } from "./styles";

export type Props = {
  $hasBottomBannerAd: boolean;
  reference: linkStoryStyleCardLinkArticle$key;
};

export const StoryStyleCardLink: FunctionComponent<Props> = ({
  $hasBottomBannerAd,
  reference: reference_,
}) => {
  const { articleCardIndex } = useStoryStyleCardContext();

  const storyStyleLink = useFragment(
    graphql`
      fragment linkStoryStyleCardLinkArticle on Article {
        ...entityLink
        urlAlias
      }
    `,
    reference_,
  );
  const handleClick = () => {
    sendGATracking({
      action: `Story Card/Read more/Style/Click`,
      category: "Story Card",
      label: storyStyleLink.urlAlias,
      value: articleCardIndex + 1,
    });

    sendGA4Tracking({
      action: "click",
      category: "storycard",
      customized_parameters: {
        cta_type: "read_more",
        destination_url: storyStyleLink.urlAlias,
      },
      subcategory: "",
    });
  };
  return (
    <CardLinkContainer $hasBottomBannerAd={$hasBottomBannerAd}>
      <StyledEntityLink
        query={{ module: tracking.module.Article, pgtype: `story_card_${articleCardIndex + 1}` }}
        reference={storyStyleLink}
        onClick={handleClick}
      >
        read more
      </StyledEntityLink>
    </CardLinkContainer>
  );
};

StoryStyleCardLink.displayName = "StoryStyleCardLink";
